<template>
    <div class="stock-search-panel">
        <div class="input-container">
            <i class="fas fa-search search-icon"></i>
            <input class="search-box" v-model="searchQuery" @input="handleInputChange" type="text" :placeholder="$t('common.search')"/>
            <i v-if="searchQuery" class="fas fa-times clear-icon" @click="clear()"></i>
        </div>


        <div v-if="filteredStocks.length" class="stock-list">
            <div v-for="stock in filteredStocks" :key="stock.code" class="stock-item" @click="selectStock(stock)">
                <div class="stock-info">
                    <span class="symbol">{{ stock.code }}</span>
                    <span class="name">{{ truncatedName(stock.name) }}</span>
                </div>
                <div class="stock-prices">
                    <!-- <span class="price">{{ stock.price | numberDisplay }}</span> -->
                    <span class="price-change box-100"
                        :class="{ 'positive': stock.change > 0, 'negative': stock.change < 0 && stock.price > stock.floor, 'neutral': stock.change === 0, 'ceil': stock.price >= stock.ceil, 'floor':  stock.price <= stock.floor }">
                        <span>{{ stock.price | numberDisplay }}</span>
                        <span>{{ stock.change/100 | percentDisplay }} </span>
                    </span>
                </div>
            </div>
        </div>

        <div v-else class="no-results">
            No stocks found.
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
    name: "SeachStock",
    data() {
        return {
            searchQuery: "",
            selectedStock: null
        };
    },
    computed: {
        ...mapGetters({
            filteredStocks: 'common/filteredStocks'
        }),
        filterStocks() {
            if (this.searchQuery) {
                return this.searchQuery
                    ? this.filteredStocks.filter((stock) =>
                        stock.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                    )
                    : this.filteredStocks;
            }
        },
    },
    methods: {
        ...mapActions({
            searchStock: "common/searchStock",
        }),
        clear() {
            this.searchQuery = '';
            // this.$refs.autocomplete.value = '';
            // this.clearDefaultCode();
        },
        handleInputChange() {
            if (this.searchQuery) {
                this.searchStock(this.searchQuery);
            }
        },
        truncatedName(name) {
            if (name) {
                return name.length > 30 ? name.substring(0, 30) + "..." : name.length;
            }
        },
        selectStock(stock) {
            this.selectedStock = stock;
            this.$emit('stockSelected', stock);
        },
    }
};
</script>

<style scoped>
.stock-search-panel {
    width: 100%;
    margin: 0 auto;
}

.search-box {
    width: 100%;
    padding: 10px 30px 10px 35px;
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.input-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 400px;
}

.search-icon {
  position: absolute;
  top: 25%;
  left: 10px;
  color: var(--gray);
  font-size: 18px;
}

.clear-icon {
  position: absolute;
  top: 25%;
  right: 10px;
  color: var(--gray);
  font-size: 18px;
  cursor: pointer;
}

.stock-list {
    border: 1px solid #eee;
    padding: 5px;
    border-radius: 4px;
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #ccc;
}

.stock-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #ddd;
}

.stock-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.symbol {
    font-weight: bold;
}

.name {
    color: #555;
    font-size: 0.9em;
}

/* Price alignment (right side) */
.stock-prices {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
}

.price {
    font-weight: bold;
}

/* No results found message */
.no-results {
    text-align: center;
    color: var(--gray);
}
</style>